import React from "react";
import { formatKey } from "../../_helper";
import StarIcon from "../Svgs/StarIcon";

const CourseBasicData = ({
  title,
  data,
  columns = 2,
  img,
  className = "tw-container tw-mx-auto tw-p-5 tw-bg-white tw-rounded-[10px] tw-shadow-md tw-relative",
}) => {
  const gridColumnsClass =
    columns === 1
      ? "tw-grid-cols-1"
      : columns === 2
      ? "lg:tw-grid-cols-2"
      : columns === 3
      ? "lg:tw-grid-cols-3"
      : `lg:tw-grid-cols-${columns}`;

  return (
    <section className={className}>
      {img !== undefined && (
        <div className="tw-absolute tw-size-16 lg:tw-size-20 tw-top-4 tw-rounded-full tw-right-10 tw-bg-white tw-shadow-lg tw-border-2 tw-p-2 tw-border-primary/5">
          <img
            src={img || "/imgs/courseDefaultImage.png"}
            alt="Course"
            className="tw-size-full tw-rounded-full tw-object-cover"
          />
        </div>
      )}
      <h3 className="tw-text-xl tw-font-semibold tw-text-red-600 tw-mb-4 tw-border-b tw-pb-2">
        {title}
      </h3>
      <div
        className={`tw-grid ${gridColumnsClass}  tw-grid-cols-1  tw-gap-2 tw-text-gray-700`}
      >
        {data &&
          Object.entries(data).map(([key, value]) => (
            <div key={key}>
              <p>
                <strong className="tw-text-primary">{formatKey(key)}:</strong>{" "}
                {key === "rating" ? (
                  <span className="tw-ms-4 tw-inline-block">
                    {Array.from(
                      { length: +value || 0 },
                      (_, index) => index + 1
                    ).map((_, index) => (
                      <StarIcon
                        key={`star-${key}-${index}`}
                        className="tw-w-5 tw-inline-block"
                      />
                    ))}
                  </span>
                ) : (
                  value
                )}
              </p>
            </div>
          ))}
      </div>
    </section>
  );
};

export default CourseBasicData;
